<script>
import Chart from "./chart";
import TransferIncomeToWallet from "./transfer-income-to-wallet";

/**
 * Dashboard component
 */
export default {
  components: {
    TransferIncomeToWallet,
    Chart,
  },
  data() {
    return {
      title: "کیف پول من",
      items: [
        {
          text: "کیف پول من",
          active: true,
        },
      ],
      income: 0,
      wallet_balance: 0,
      backAccountsDetail: JSON.parse(
        JSON.stringify(this.$store.state.tables.bankAccounts)
      ),
    };
  },
  mounted() {
    this.fetchMetaData();
  },
  methods: {
    fetchMetaData() {
      this.$axios.get("financial/meta-data").then((res) => {
        this.income = res.data.income;
        this.wallet_balance = res.data.wallet_balance;
        this.backAccountsDetail.data = res.data.bank_accounts;
        this.$store.commit("tables/UPDATE_TABLE_DETAIL", {
          key: "bankAccounts",
          table: JSON.parse(JSON.stringify(this.backAccountsDetail)),
        });
      });
    },
    incomeTransfer() {
      this.wallet_balance += this.income;
      this.income = 0;
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <template>
      <div class="row">
        <div class="col-md-6">
          <div class="card">
            <div class="card-body">
              <h5>موجودی کیف پول</h5>
              <p class="mt-4">
                موجودی: {{ $helper.formatPrice(wallet_balance) }} تومان
              </p>
              <router-link :to="{ name: 'wallet.charge' }">
                <b-button variant="success">افزایش موجودی کیف پول</b-button>
              </router-link>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <transfer-income-to-wallet
            @income_transfer="incomeTransfer"
            :income="income"
          ></transfer-income-to-wallet>
        </div>
        <div class="col-12">
          <chart />
        </div>
      </div>
    </template>
  </Layout>
</template>
